import { render } from "./ProgressBar.vue?vue&type=template&id=2942e9a4&scoped=true&bindings={}"
import script from "./ProgressBar.vue?vue&type=script&lang=ts"
export * from "./ProgressBar.vue?vue&type=script&lang=ts"

import "./ProgressBar.vue?vue&type=style&index=0&id=2942e9a4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2942e9a4"

export default script